import React, { ReactElement } from 'react';

import { withDataLayer } from '@pb/shared/utilities/with-data-layer';
import { TButtonProperties, TOnClickEvent } from './button.types';
import { StyledButton } from './button.styled';

export function Button({
    appearance = 'default',
    level = 'primary',
    showOnDarkBackground = false,
    width = 'default',
    onClick,
    ...properties
}: TButtonProperties): ReactElement {
    return (
        <StyledButton
            appearance={appearance}
            showOnDarkBackground={showOnDarkBackground}
            width={width}
            level={level}
            onClick={(event: TOnClickEvent) => {
                withDataLayer(dataLayer => {
                    dataLayer.push({
                        event: 'Button',
                        appearance,
                        level,
                        showOnDarkBackground,
                        width,
                        ...properties,
                    });
                });

                if (typeof onClick === 'function') {
                    onClick(event);
                }
            }}
            {...properties}
        />
    );
}
